import React from "react";
import LoginPage from "src/components/auth/login/loginWithEmail";

export default function LoginWithEmailContainer() {
  return (
    <React.Fragment>
      <LoginPage />
    </React.Fragment>
  );
}
